import { batch, signal } from "@preact/signals-react"

export const priceChangesTableData = signal([])
export const priceChangesOverview = signal({})
export const priceChangesIsEmpty = signal(false)
export const priceChangesSubmittedFilters = signal({})
export const priceChangesStockEvolutionFilters = signal({})
export const priceChangesPriceEvolutionFilters = signal({})
export const pricingChangesEvolutionCurrentPeriod = signal("")
export const pricingChangesEndDate = signal("")

//Functions
export const resetPricingChangesSignals = () => batch(() => {
	priceChangesTableData.value = []
	priceChangesOverview.value = {}
	priceChangesIsEmpty.value = false
	priceChangesStockEvolutionFilters.value = {}
	priceChangesPriceEvolutionFilters.value = {}
	insightsIsOpen.value = false
	insightsData.value = ""
	insightsIsLoading.value = false
	insightsError.value = null
})

//Form
export const priceChangesReportFormIsOpen = signal(false)

//Insights
export const insightsIsOpen = signal(false)
export const insightsData = signal("")
export const insightsIsLoading = signal(false)
export const insightsError = signal(null)
